import { createRouter, createWebHistory } from 'vue-router';
import { menuStore, userTokenStore, userInfoStore } from "@/store/store.js";

import Login from '@/views/login/index.vue';
import AdminLogin from '@/views/login/adminLogin.vue';
import Index from "@/views/index.vue";
import ListClub from "@/views/club/listClub.vue";
import ListMember from "@/views/member/listMember.vue";
import NotFound from "@/views/notFound/index.vue"
import ListPost from "@/views/post/listPost.vue";
import addPost from "@/views/post/addPost.vue";
import listOnlineStore from "@/views/onlineStore/listOnlineStore.vue";
import addOnlineStore from "@/views/onlineStore/addOnlineStore.vue";
import listItem from "@/views/item/listItem.vue";
import addItem from "@/views/item/addItem.vue";
import addItemProp from "@/views/itemProp/addItemProp.vue";
import listItemProp from "@/views/itemProp/listItemProp.vue"
import listPostItem from "@/views/post/listPostItem.vue"
import listPostGroup from "@/views/post/listPostGroup.vue"
import listOnlineStoreItem from "@/views/onlineStore/listOnlineStoreItem.vue"
import listOnlineStoreGroup from "@/views/onlineStore/listOnlineStoreGroup.vue"
import listPostOrder from "@/views/orderManagement/listPostOrder.vue";
import editPostOrder from "@/views/orderManagement/editPostOrder.vue";
import listOnlineStoreOrder from "@/views/orderManagement/listOnlineStoreOrder.vue";
import editOnlineStoreOrder from "@/views/orderManagement/editOnlineStoreOrder.vue";
import listClubGroup from "@/views/club/listClubGroup.vue";
import listClubSign from "@/views/club/listClubSign.vue";
import editClubSign from "@/views/club/editClubSign.vue";
import listClubCourse from "@/views/club/listClubCourse.vue";
import editClubCourseSign from "@/views/club/editClubCourseSign.vue";
import listClubCourseSign from "@/views/club/listClubCourseSign.vue";
import listInvoice from "@/views/invoice/listInvoice.vue";
import editInvoice from "@/views/invoice/editInvoice.vue";
import listSystemAdmin from "@/views/user/listSystemAdmin.vue";
import listSystemRole from "@/views/user/listSystemRole.vue";
import listTenant from "@/views/tenant/listTenant.vue";
import listOrdinary from "@/views/user/listOrdinary.vue";
import addSystemAdmin from "@/views/user/addSystemAdmin.vue";
import editSystemRole from "@/views/user/editSystemRole.vue";
import addOrdinary from "@/views/user/addOrdinary.vue";
import wechatBindSuccess from "@/views/wechatBind/wechatBindSuccess.vue";
import wechatBindFail from "@/views/wechatBind/wechatBindFail.vue";
import listClubCompetition from "@/views/club/listClubCompetition.vue";
import listMerchandiseOrder from "@/views/club/listMerchandiseOrder.vue";
import listClubInstructor from "@/views/club/listClubInstructor.vue";
import listClubCourseRecord from "@/views/club/listClubCourseRecord.vue";
import addClubCourseRecord from "@/views/club/addClubCourseRecord.vue";
import editTenant from "@/views/tenant/editTenant.vue";
import listCyclingRoute from "@/views/cyclingRoute/listCyclingRoute.vue";
import editCyclingRoute from "@/views/cyclingRoute/editCyclingRoute.vue";
import listClubCompetitionSign from "@/views/club/listClubCompetitionSign.vue";
import editClubCompetitionSign from "@/views/club/editClubCompetitionSign.vue";
import platformData from "@/views/platformData/platformData.vue";
import editClub from "@/views/club/editClub.vue";
import listPointsRecord from "@/views/pointsRecord/listPointsRecord.vue";
import listEleCardVoucher from "@/views/eleCardVoucher/listEleCardVoucher.vue";
import editEleCardVoucher from "@/views/eleCardVoucher/editEleCardVoucher.vue";
import listCoupon from "@/views/coupon/listCoupon.vue";
import editCoupon from "@/views/coupon/editCoupon.vue";
import listClubRecommended from "@/views/platformData/listClubRecommended.vue";
import listMemberPurchase from "@/views/member/listMemberPurchase.vue";
import listTicketRedemption from "@/views/platformData/listTicketRedemption.vue";
import { handleGetMenuFirst } from "@/hooks/user.js";
import editAccountInformation from "@/views/accountInformation/editAccountInformation.vue";
import YTindex from "@/views/YTindex.vue";
import listUser from "@/views/club/listUser.vue";
import listUserAudit from "@/views/club/listUserAudit.vue";
import listUserHistoryAudit from "@/views/club/listUserHistoryAudit.vue";
import listActivity from "@/views/club/listActivity.vue";
import editActivity from "@/views/club/editActivity.vue";
import settings from '@/views/club/settings.vue'
import YTCreateClub from "@/views/club/create/components/createClub.vue"
import manageClub from '@/views/club/manageClub.vue'
import listTags from "@/views/tags/listTags.vue";
import listTagGroups from "@/views/tags/listTagGroups.vue";
import editTagGroups from "@/views/tags/editTagGroups.vue";
import listTagAudit from "@/views/tags/listTagAudit.vue";
import editTagGroupsBindScence from "@/views/tags/editTagGroupsBindScence.vue";
import listTagAuditHistory from "@/views/tags/listTagAuditHistory.vue";
import editPostExInfo from "@/views/post/editPostExInfo.vue";
import listServiceLocation from "../views/serviceLocation/listServiceLocation.vue";
import editServiceLocation from "../views/serviceLocation/editServiceLocation.vue";
import listServiceItems from "../views/serviceItems/listServiceItems.vue";
import editServiceItems from "../views/serviceItems/editServiceItems.vue";
import arrangeServiceItems from "../views/serviceItems/arrangeServiceItems.vue";
import listServicePhotographer from "../views/servicePhotographer/listServicePhotographer.vue";
import editServicePhotographer from "../views/servicePhotographer/editServicePhotographer.vue";
import arrangeServicePhotographer from "../views/servicePhotographer/arrangeServicePhotographer.vue";
import listAdvertisements from "@/views/advertisement/listAdvertisements.vue";
import editAdvertisements from "@/views/advertisement/editAdvertisements.vue";
import readOnlyAdvertisements from "@/views/advertisement/readOnlyAdvertisements.vue";
import auditAdvertisements from "@/views/advertisement/auditAdvertisements.vue";
import listMemberPurchaseOrder from "@/views/member/listMemberPurchaseOrder.vue";
import listAllOrder from "@/views/orderManagement/listAllOrder.vue";
import listBillOrder from "@/views/orderManagement/listBillOrder.vue";
import listTenantEntryData from "@/views/tenant/listTenantEntryData.vue";
import addTenant from "@/views/tenant/addTenant.vue";
import listTenantClub from "@/views/tenant/listTenantClub.vue"
import addTenantClub from "@/views/tenant/addTenantClub.vue";
import editTenantClub from "@/views/tenant/editTenantClub.vue";
import listTenantPost from "@/views/tenant/listTenantPost.vue";
import listTenantVenue from "@/views/tenant/listTenantVenue.vue";
import listTenantBikeStore from "@/views/tenant/listTenantBikeStore.vue";
import listTenantTherapy from "@/views/tenant/listTenantTherapy.vue";
import addTenantTherapy from "@/views/tenant/addTenantTherapy.vue";
import editTenantTherapy from "@/views/tenant/editTenantTherapy.vue";
import addTherapist from "@/views/tenant/addTherapist.vue";
import editTherapist from "@/views/tenant/editTherapist.vue"
import listTenantPhotography from "@/views/tenant/listTenantPhotography.vue";
import addTenantPhotography from "@/views/tenant/addTenantPhotography.vue";
import editTenantPhotography from "@/views/tenant/editTenantPhotography.vue";
import addPhotographer from "@/views/tenant/addPhotographer.vue";
import editPhotographer from "@/views/tenant/editPhotographer.vue";
import addTenantPost from "@/views/tenant/addTenantPost.vue";
import editTenantPost from "@/views/tenant/editTenantPost.vue";
import addTenantBikeStore from "@/views/tenant/addTenantBikeStore.vue";
import editTenantBikeStore from "@/views/tenant/editTenantBikeStore.vue";
import addTenantVenue from "@/views/tenant/addTenantVenue.vue";
import editTenantVenue from "@/views/tenant/editTenantVenue.vue";
import listTherapyOrderIgnore from "@/views/orderManagement/listTherapyOrderIgnore.vue";
import listPhotographyOrderIgnore from "@/views/orderManagement/listPhotographyOrderIgnore.vue";
import listBikeMaintenanceOrderIgnore from "@/views/orderManagement/listBikeMaintenanceOrderIgnore.vue";
import listPostOrderIgnore from "@/views/orderManagement/listPostOrderIgnore.vue";
import addBikeStoreMember from "@/views/tenant/addBikeStoreMember.vue";
import editBikeStoreMember from "@/views/tenant/editBikeStoreMember.vue";
import {editCoach} from "@/api/coach/coach.js";
import addVenueCoach from "@/views/tenant/addVenueCoach.vue";
import editVenueCoach from "@/views/tenant/editVenueCoach.vue";
import eventAddActivity from "@/views/eventManagement/addActivity.vue"
import eventListActivity from "@/views/eventManagement/listActivity.vue"
import listTenantBrand from "@/views/tenant/listTenantBrand.vue";
import addTenantBrand from "@/views/tenant/addTenantBrand.vue";
import editTenantBrand from "@/views/tenant/editTenantBrand.vue";
import editBrandMember from "@/views/tenant/editBrandMember.vue";
import addBrandMember from "@/views/tenant/addBrandMember.vue";
import listItemBizCategory from "@/views/item/listItemBizCategory.vue";
import editPrimaryCategory from "@/views/item/editPrimaryCategory.vue";
import editSecondaryCategory from "@/views/item/editSecondaryCategory.vue";
import listMallOrderManage from "@/views/mallOrderManage/listMallOrderManage.vue";
import listMallOrderManageStore from "@/views/mallOrderManage/listMallOrderManageStore.vue";

const routes = [
    {
        path: '/',
        redirect: '/login',
    },
    // {
    //     path: '/index',
    //     redirect: async () => {
    //         console.log("run in here")
    //         const targetPath = await handleGetMenuFirst();
    //         console.log("targetPath", targetPath)
    //         return targetPath;
    //     },
    // },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            title: '登录'
        }
    },
    {
        path: '/superAdminLogin',
        name: 'superAdminLogin',
        component: AdminLogin,
        meta: {
            title: '超级管理员登录'
        }
    },
    {
        // path: '/index',
        name: 'template',
        component: Index,
        children: [
            {
                path: '/listClub',
                name: '管理俱乐部-旧版',
                component: ListClub,
                meta: {
                    title: '管理俱乐部',
                    bread: ['设置', '俱乐部', {
                        title: '管理俱乐部',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#005", "#005_4", "#005_4_1"],
                    permission: ["club:view", "club:edit", "club:add", "club:delete"]
                }
            },
            {
                path: '/listMember',
                name: '会员列表',
                component: ListMember,
                meta: {
                    title: '会员列表',
                    bread: ['会员管理', {
                        title: '会员列表',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#002", "#002_1"],
                    permission: ["member:view", "member:view:info", "member:delete"]
                }
            },
            {
                path: '/listPost',
                name: '查询门店',
                component: ListPost,
                meta: {
                    title: '查询门店',
                    bread: ['设置', '门店', {
                        title: '查询门店',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#005", "#005_1", "#005_1_1"],
                    permission: ["store:view", "store:edit", "store:delete", "store:add"]
                }
            },
            {
                path: '/addPost',
                name: '增加门店',
                component: addPost,
                meta: {
                    title: '增加门店',
                    bread: ['设置', '门店', {
                        title: '增加门店',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#005", "#005_1", "#005_1_1"],
                    permission: []
                }
            },
            {
                path: '/listOnlineStore',
                name: '查询网店',
                component: listOnlineStore,
                meta: {
                    title: '查询网店',
                    bread: ['设置', '网店', {
                        title: '查询网店',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#005", "#005_2", "#005_2_1"],
                    permission: ["onlineStore:view", "onlineStore:edit", "onlineStore:delete", "onlineStore:add"]
                }
            },
            {
                path: '/addOnlineStore',
                name: '增加网店',
                component: addOnlineStore,
                meta: {
                    title: '增加网店',
                    bread: ['设置', '网店', {
                        title: '增加网店',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#005", "#005_2", "#005_2_1"],
                    permission: []
                }
            },
            {
                path: '/listItem',
                name: '查询商品',
                component: listItem,
                meta: {
                    title: '查询商品',
                    bread: ['设置', '商品', {
                        title: '查询商品',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#005", "#005_3", "#005_3_1"],
                    permission: [
                        "goods:view",
                        "goods:edit",
                        "goods:delete",
                        "goods:add",
                        "good:edit:channel",
                        "virtualGoods:add",
                        "virtualGoods:edit",
                    ]
                }
            },
            {
                path: '/addItem',
                name: '编辑商品',
                component: addItem,
                meta: {
                    title: '编辑商品',
                    bread: ['设置', '商品', {
                        title: '编辑商品',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#005", "#005_3", "#005_3_1"],
                    permission: [
                        "goods:view",
                        "goods:edit",
                        "goods:delete",
                        "goods:add",
                        "good:edit:channel",
                        "virtualGoods:add",
                        "virtualGoods:edit",
                        "comboGoods:add",
                        "comboGoods:edit",
                        "voucher:add",
                        "voucher:edit",
                        "coupon:add1",
                        "coupon:edit1"
                    ]
                }
            },
            {
                path: '/addItemProp',
                name: '增加商品属性',
                component: addItemProp,
                meta: {
                    title: '增加商品属性',
                    bread: ['设置', '商品', {
                        title: '增加商品属性',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#005", "#005_3", "#005_3_2"],
                    permission: ["propertyGroup:view:info", "propertyGroup:edit", "propertyGroup:add"]
                }
            },
            {
                path: '/listItemProp',
                name: '查询商品属性',
                component: listItemProp,
                meta: {
                    title: '查询商品属性',
                    bread: ['设置', '商品', {
                        title: '查询商品属性',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#005", "#005_3", "#005_3_2"],
                    permission: ["propertyGroup:view", "propertyGroup:edit", "propertyGroup:delete", "propertyGroup:add"]
                }
            },
            {
                path: '/listPostItem',
                name: '门店商品',
                component: listPostItem,
                meta: {
                    title: '门店商品',
                    bread: ['门店', {
                        title: '门店商品',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#004", "#004_1"],
                    permission: ["storeGoods:view", "storeGoodsState:edit", "storeGroup:view", "storeGroup:edit"]
                }
            },
            {
                path: '/listPostGroup',
                name: '门店分组',
                component: listPostGroup,
                meta: {
                    title: '门店分组',
                    bread: ['门店', {
                        title: '门店分组',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#004", "#004_2"],
                    permission: ["storeGroupPage:view", "storeGroup:delete", "storeGroup:add"]
                }
            },
            {
                path: '/listOnlineStoreItem',
                name: '网店商品',
                component: listOnlineStoreItem,
                meta: {
                    title: '网店商品',
                    bread: ['网店', {
                        title: '网店商品',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#003", "#003_1"],
                    permission: ["onlineStoreGoods:view", "onlineStoreGoodsState:edit", "onlineStoreGroup:view", "onlineStoreGroup:edit"]
                }
            },
            {
                path: '/listOnlineStoreGroup',
                name: '网店分组',
                component: listOnlineStoreGroup,
                meta: {
                    title: '网店分组',
                    bread: ['网店', {
                        title: '网店分组',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#003", "#003_2"],
                    permission: ["onlineStoreGroupPage:view", "onlineStoreGroup:delete", "onlineStoreGroup:add"]
                }
            },
            {
                path: '/listPostOrder',
                name: '管理门店订单',
                component: listPostOrder,
                meta: {
                    title: '管理订单',
                    bread: ['门店', {
                        title: '管理门店订单',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#004", "#004_3"],
                    permission: ["orderAdmin:view", "orderAdmin:edit"]
                }
            },
            {
                path: '/editPostOrder',
                name: '编辑门店订单',
                component: editPostOrder,
                meta: {
                    title: '编辑门店订单',
                    bread: ['门店', '管理门店订单', {
                        title: '编辑订单',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#004", "#004_3"],
                    permission: ["orderAdmin:view:info", "orderAdmin:edit"]
                }
            },
            {
                path: '/listOnlineStoreOrder',
                name: '管理网店订单',
                component: listOnlineStoreOrder,
                meta: {
                    title: '管理订单',
                    bread: ['网店', {
                        title: '管理网店订单',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#003", "#003_3"],
                    permission: ["onlineOrderAdmin:view", "onlineOrderAdmin:edit"]
                }
            },
            {
                path: '/editOnlineStoreOrder',
                name: '编辑网店订单',
                component: editOnlineStoreOrder,
                meta: {
                    title: '编辑网店订单',
                    bread: ['网店', '管理网店订单', {
                        title: '编辑订单',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#003", "#003_3"],
                    permission: []
                }
            },
            {
                path: '/listClubGroup',
                name: '分组',
                component: listClubGroup,
                meta: {
                    title: '分组',
                    bread: ['俱乐部', {
                        title: '分组',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#001", "#001_1"],
                    permission: ["clubGroup:view", "clubGroup:delete", "clubGroup:add"]
                }
            },
            {
                path: '/listClubSign',
                name: '活动报名',
                component: listClubSign,
                meta: {
                    title: '活动报名',
                    bread: ['俱乐部', {
                        title: '活动报名',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#001", "#001_3"],
                    permission: ["activityOrder:view", "activityOrderState:edit"]
                }
            },
            {
                path: '/editClubSign',
                name: '编辑活动报名',
                component: editClubSign,
                meta: {
                    title: '编辑活动报名',
                    bread: ['俱乐部', '活动报名', {
                        title: '编辑活动报名',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#001", "#001_3"],
                    permission: []
                }
            },
            {
                path: '/listClubCourse',
                name: '课程',
                component: listClubCourse,
                meta: {
                    title: '课程',
                    bread: ['俱乐部', {
                        title: '课程',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#001", "#001_4"],
                    permission: ["clubCourse:view", "clubCourseState:edit", "clubCourseGroup:edit"]
                }
            },
            {
                path: '/listClubCourseSign',
                name: '课程订单',
                component: listClubCourseSign,
                meta: {
                    title: '课程订单',
                    bread: ['俱乐部', {
                        title: '课程订单',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#001", "#001_5"],
                    permission: ["courseOrder:view", "courseOrder:edit"]
                }
            },
            {
                path: '/editClubCourseSign',
                name: '编辑课程订单',
                component: editClubCourseSign,
                meta: {
                    title: '编辑课程订单',
                    bread: ['俱乐部', '课程订单', {
                        title: '编辑课程订单',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#001", "#001_5"],
                    permission: []
                }
            },
            {
                path: '/listInvoice',
                name: '查询发票',
                component: listInvoice,
                meta: {
                    title: '查询发票',
                    bread: ['设置', '发票', {
                        title: '查询发票',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#005", "#005_5", "#005_5_1"],
                    permission: ["adminInvoice:view", "adminInvoice:view:edit"]
                }
            },
            {
                path: '/editInvoice',
                name: '编辑发票',
                component: editInvoice,
                meta: {
                    title: '查询发票',
                    bread: ['设置', '发票', {
                        title: '编辑发票',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#005", "#005_5", "#005_5_1"],
                    permission: []
                }
            },
            {
                path: '/listSystemAdmin',
                name: '系统用户管理',
                component: listSystemAdmin,
                meta: {
                    title: '系统用户管理',
                    bread: ['平台', {
                        title: '系统用户管理',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#006", "#006_1"],
                    permission: ["systemAdmin:view", "systemAdmin:add", "systemAdmin:delete", "systemAdmin:edit", "tenant:view"]
                }
            },
            {
                path: '/addSystemAdmin',
                name: '增加系统用户',
                component: addSystemAdmin,
                meta: {
                    title: '增加系统用户',
                    bread: ['平台', '系统用户管理', {
                        title: '增加系统用户',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#006", "#006_1"],
                    permission: []
                }
            },
            {
                path: '/listSystemRole',
                name: '角色管理',
                component: listSystemRole,
                meta: {
                    title: '角色管理',
                    bread: ['平台', {
                        title: '角色管理',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#006", "#006_2"],
                    permission: ["systemRole:view", "systemRole:add", "systemRole:edit", "systemRole:delete"]
                }
            },
            {
                path: '/editSystemRole',
                name: '增加角色',
                component: editSystemRole,
                meta: {
                    title: '角色管理',
                    bread: ['平台', '角色管理', {
                        title: '增加角色',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#006", "#006_2"],
                    permission: []
                }
            },
            {
                path: '/listTenant',
                name: '商家管理',
                component: listTenant,
                meta: {
                    title: '商家管理',
                    bread: ['商家与品牌', {
                        title: '商家管理',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_2"],
                    permission: []
                }
            },
            {
                path: '/listOrdinary',
                name: '用户管理',
                component: listOrdinary,
                meta: {
                    title: '用户管理',
                    bread: ['设置', '用户', {
                        title: '用户管理',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#005", "#005_6"],
                    permission: ["ordinaryAdmin:view", "ordinaryAdmin:add", "ordinaryAdmin:delete"]
                }
            },
            {
                path: '/addOrdinary',
                name: '增加用户',
                component: addOrdinary,
                meta: {
                    title: '增加用户',
                    bread: ['设置', '用户', '用户管理', {
                        title: '增加用户',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#005", "#005_6"],
                    permission: []
                }
            },
            {
                path: '/listClubCompetition',
                name: '赛事',
                component: listClubCompetition,
                meta: {
                    title: '赛事',
                    bread: ['俱乐部', {
                        title: '赛事',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#001", "#001_6"],
                    permission: ["competition:view", "competitionStoreGoodsState:edit"]
                }
            },
            {
                path: '/listMerchandiseOrder',
                name: '周边订单',
                component: listMerchandiseOrder,
                meta: {
                    title: '周边订单',
                    bread: ['俱乐部', '赛事', {
                        title: '周边订单',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#001", "#001_6"],
                    permission: ["competition:view", "competitionStoreGoodsState:edit"]
                }
            },
            {
                path: '/listClubInstructor',
                name: '教练',
                component: listClubInstructor,
                meta: {
                    title: '教练',
                    bread: ['俱乐部', {
                        title: '教练',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#001", "#001_8"],
                    permission: ["coach:view", "coach:add", "coach:edit", "coach:delete", "coachState:edit"]
                }
            },
            {
                path: '/listClubCourseRecord',
                name: '课程记录',
                component: listClubCourseRecord,
                meta: {
                    title: '课程记录',
                    bread: ['俱乐部', {
                        title: '课程记录',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#001", "#001_7"],
                    permission: ["lesson:add", "lesson:edit", "lesson:view"]
                }
            },
            {
                path: '/addClubCourseRecord',
                name: '编辑课程记录',
                component: addClubCourseRecord,
                meta: {
                    title: '编辑课程记录',
                    bread: ['俱乐部', '课程记录', {
                        title: '编辑课程记录',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#001", "#001_7"],
                    permission: []
                }
            },
            {
                path: '/editTenant',
                name: '商家详情页',
                component: editTenant,
                meta: {
                    title: '商家详情页',
                    bread: ['商家与品牌', '商家管理', {
                        title: '商家详情页',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_2"],
                    permission: []
                }
            },
            {
                path: '/listCyclingRoute',
                name: '查询线路',
                component: listCyclingRoute,
                meta: {
                    title: '查询线路',
                    bread: ['设置', '骑行', {
                        title: '查询线路',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#005", "#005_7", "#005_7_1"],
                    permission: ["cyclingRoute:view", "cyclingRoute:add", "cyclingRoute:edit", "cyclingRoute:delete", "cyclingRouteTag:edit"]
                }
            },
            {
                path: '/editCyclingRoute',
                name: '编辑线路',
                component: editCyclingRoute,
                meta: {
                    title: '编辑线路',
                    bread: ['设置', '骑行', '查询线路', {
                        title: '编辑线路',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#005", "#005_7", "#005_7_1"],
                    permission: []
                }
            },
            {
                path: '/listClubCompetitionSign',
                name: '赛事报名',
                component: listClubCompetitionSign,
                meta: {
                    title: '赛事报名',
                    bread: ['俱乐部', {
                        title: '赛事报名',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#001", "#001_10"],
                    permission: ["competitionOrder:view", "competitionOrder:view:info"]
                }
            },
            {
                path: '/editClubCompetitionSign',
                name: '编辑赛事报名',
                component: editClubCompetitionSign,
                meta: {
                    title: '编辑赛事报名',
                    bread: ['俱乐部', '赛事报名', {
                        title: '编辑赛事报名',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#001", "#001_10"],
                    permission: []
                }
            },
            {
                path: '/platformData',
                name: '统计',
                component: platformData,
                meta: {
                    title: '统计',
                    bread: ['平台', {
                        title: '统计',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#006", "#006_4"],
                    permission: []
                }
            },
            {
                path: '/editClub',
                name: '编辑俱乐部',
                component: editClub,
                meta: {
                    title: '编辑俱乐部',
                    bread: ['设置', '俱乐部', {
                        title: '编辑俱乐部',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#005", "#005_4", "#005_4_1"],
                    permission: []
                }
            },
            {
                path: '/listPointsRecord',
                name: '积分记录',
                component: listPointsRecord,
                meta: {
                    title: '积分记录',
                    bread: ['平台', '营销', {
                        title: '积分记录',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#006", "#006_5", "#006_5_1"],
                    permission: ['memberCreditLog:view', 'memberCreditLog:add']
                }
            },
            {
                path: '/listEleCardVoucher',
                name: '电子卡券记录',
                component: listEleCardVoucher,
                meta: {
                    title: '电子卡券记录',
                    bread: ['平台', '营销', {
                        title: '电子卡券记录',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#006", "#006_5", "#006_5_2"],
                    permission: ['voucherUser:view', 'voucherUser:add', 'voucherUser:edit']
                }
            },
            {
                path: '/editEleCardVoucher',
                name: '编辑电子卡券',
                component: editEleCardVoucher,
                meta: {
                    title: '编辑电子卡券',
                    bread: ['平台', '营销', '电子卡券记录', {
                        title: '编辑电子卡券',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#006", "#006_5", "#006_5_2"],
                    permission: []
                }
            },
            {
                path: '/listCoupon',
                name: '优惠券记录',
                component: listCoupon,
                meta: {
                    title: '优惠券记录',
                    bread: ['平台', '营销', {
                        title: '优惠券记录',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#006", "#006_5", "#006_5_3"],
                    permission: ['coupon:view', 'coupon:add', 'coupon:edit']
                }
            },
            {
                path: '/editCoupon',
                name: '编辑优惠券记录',
                component: editCoupon,
                meta: {
                    title: '优惠券记录',
                    bread: ['平台', '营销', '优惠券记录', {
                        title: '编辑优惠券记录',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#006", "#006_5", "#006_5_3"],
                    permission: []
                }
            },
            {
                path: '/listClubRecommended',
                name: '商家推荐用户数',
                component: listClubRecommended,
                meta: {
                    title: '商家推荐用户数',
                    bread: ['平台', '统计', {
                        title: '商家推荐用户数',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#006", "#006_4"],
                    permission: ["memberLevelLogStatistics:info", "memberLevelLog:view"]
                }
            },
            {
                path: '/listMemberPurchase',
                name: '会员购买记录',
                component: listMemberPurchase,
                meta: {
                    title: '会员购买记录',
                    bread: ['用户', '查询用户', {
                        title: '会员购买记录',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#002", "#002_1"],
                    permission: []
                }
            },
            {
                path: '/listTicketRedemption',
                name: '卡券核销',
                component: listTicketRedemption,
                meta: {
                    title: '卡券核销',
                    bread: ['平台', '统计', {
                        title: '卡券核销',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#006", "#006_4"],
                    permission: ["adminTicketPageRedemption:view", "adminTicketPageRedemption:export"]
                }
            },
            {
                path: '/editAccountInformation',
                name: '我的信息',
                component: editAccountInformation,
                meta: {
                    title: '我的信息',
                    bread: ['设置', {
                        title: '我的信息',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#005", "#005_9"],
                    permission: []
                }
            },
            {
                path: '/listTags',
                name: '标签管理',
                component: listTags,
                meta: {
                    title: '标签管理',
                    bread: ['平台', '标签', {
                        title: '标签管理',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#006", "#006_6", "#006_6_1"],
                    permission: []
                }
            },
            {
                path: '/listTagGroups',
                name: '标签分组管理',
                component: listTagGroups,
                meta: {
                    title: '标签分组管理',
                    bread: ['平台', '标签', {
                        title: '标签分组管理',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#006", "#006_6", "#006_6_2"],
                    permission: []
                }
            },
            {
                path: '/editTagGroups',
                name: '编辑分组',
                component: editTagGroups,
                meta: {
                    title: '编辑分组',
                    bread: ['平台', '标签', '标签分组管理', {
                        title: '编辑分组',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#006", "#006_6", "#006_6_2"],
                    permission: []
                }
            },
            {
                path: '/listTagAudit',
                name: '审核管理',
                component: listTagAudit,
                meta: {
                    title: '审核管理',
                    bread: ['平台', '标签', {
                        title: '审核管理',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#006", "#006_6", "#006_6_3"],
                    permission: []
                }
            },
            {
                path: '/editTagGroupsBindScence',
                name: '标签应用管理',
                component: editTagGroupsBindScence,
                meta: {
                    title: '标签应用管理',
                    bread: ['平台', '标签', {
                        title: '标签应用管理',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#006", "#006_6", "#006_6_4"],
                    permission: []
                }
            },
            {
                path: '/listTagAuditHistory',
                name: '审核历史记录',
                component: listTagAuditHistory,
                meta: {
                    title: '审核历史记录',
                    bread: ['平台', '标签', '审核管理', {
                        title: '历史记录',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#006", "#006_6", "#006_6_3"],
                    permission: []
                }
            },
            {
                path: '/editPostExInfo',
                name: '编辑扩展信息',
                component: editPostExInfo,
                meta: {
                    title: '编辑扩展信息',
                    bread: ['设置', '门店', {
                        title: '编辑扩展信息',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#005", "#005_1", "#005_1_1"],
                    permission: []
                }
            },
            {
                path: '/listServiceLocation',
                name: '服务地点',
                component: listServiceLocation,
                meta: {
                    title: '服务地点',
                    bread: ['营销管理', '服务管理', {
                        title: '服务地点',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#007", "#007_1", "#007_1_2"],
                    permission: []
                }
            },
            {
                path: '/editServiceLocation',
                name: '编辑服务地点',
                component: editServiceLocation,
                meta: {
                    title: '编辑服务地点',
                    bread: ['营销管理', '服务管理', '服务地点', {
                        title: '编辑服务地点',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#007", "#007_1", "#007_1_2"],
                    permission: []
                }
            },
            {
                path: '/listServiceItems',
                name: '项目管理',
                component: listServiceItems,
                meta: {
                    title: '项目管理',
                    bread: ['营销管理', '服务管理', {
                        title: '项目管理',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#007", "#007_1", "#007_1_1"],
                    permission: []
                }
            },
            {
                path: '/editServiceItems',
                name: '编辑服务项目',
                component: editServiceItems,
                meta: {
                    title: '编辑服务项目',
                    bread: ['营销管理', '服务管理', '项目管理', {
                        title: '编辑服务项目',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#007", "#007_1", "#007_1_1"],
                    permission: []
                }
            },
            {
                path: '/arrangeServiceItems',
                name: '服务项目排班',
                component: arrangeServiceItems,
                meta: {
                    title: '服务项目排班',
                    bread: ['营销管理', '服务管理', '项目管理', {
                        title: '服务项目排班',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#007", "#007_1", "#007_1_1"],
                    permission: []
                }
            },
            {
                path: '/listServicePhotographer',
                name: '服务摄影管理',
                component: listServicePhotographer,
                meta: {
                    title: '摄影师管理',
                    bread: ['营销管理', '服务管理', {
                        title: '摄影师管理',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#007", "#007_1", "#007_1_3"],
                    permission: []
                }
            },
            {
                path: '/editServicePhotographer',
                name: '编辑服务摄影师',
                component: editServicePhotographer,
                meta: {
                    title: '编辑服务摄影师',
                    bread: ['营销管理', '服务管理', '摄影师管理', {
                        title: '编辑服务摄影师',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#007", "#007_1", "#007_1_3"],
                    permission: []
                }
            },
            {
                path: '/arrangeServicePhotographer',
                name: '摄影师排班',
                component: arrangeServicePhotographer,
                meta: {
                    title: '摄影师排班',
                    bread: ['营销管理', '服务管理', '摄影师管理', {
                        title: '摄影师排班',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#007", "#007_1", "#007_1_3"],
                    permission: []
                }
            },
            {
                path: '/listAdvertisements',
                name: '广告管理',
                component: listAdvertisements,
                meta: {
                    title: '广告管理',
                    bread: ['营销管理', {
                        title: '广告管理',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#007", "#007_2"],
                    permission: []
                }
            },
            {
                path: '/editAdvertisements',
                name: '编辑广告',
                component: editAdvertisements,
                meta: {
                    title: '编辑广告',
                    bread: ['营销管理', '广告管理', {
                        title: '编辑广告',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#007", "#007_2"],
                    permission: []
                }
            },
            {
                path: '/readOnlyAdvertisements',
                name: '广告详情',
                component: readOnlyAdvertisements,
                meta: {
                    title: '广告详情',
                    bread: ['营销管理', '广告管理', {
                        title: '广告详情',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#007", "#007_2"],
                    permission: []
                }
            },
            {
                path: '/auditAdvertisements',
                name: '广告审批',
                component: auditAdvertisements,
                meta: {
                    title: '广告详情',
                    bread: ['营销管理', '广告管理', {
                        title: '广告审批',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#007", "#007_2"],
                    permission: []
                }
            },
            {
                path: '/listMemberPurchaseOrder',
                name: '购买会员订单',
                component: listMemberPurchaseOrder,
                meta: {
                    title: '购买会员订单',
                    bread: ['会员管理', {
                        title: '购买会员订单',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#002", "#002_2"],
                    permission: []
                }
            },
            {
                path: '/listAllOrder',
                name: '订单中心',
                component: listAllOrder,
                meta: {
                    title: '订单中心',
                    bread: ['报表', {
                        title: '订单中心',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#008", "#008_1"],
                    permission: []
                }
            },
            {
                path: '/listBillOrder',
                name: '账单明细',
                component: listBillOrder,
                meta: {
                    title: '账单明细',
                    bread: ['报表', {
                        title: '账单明细',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#008", "#008_2"],
                    permission: []
                }
            },
            {
                path: '/listTenantEntryData',
                name: '进驻申请资料',
                component: listTenantEntryData,
                meta: {
                    title: '进驻申请资料',
                    bread: ['商家与品牌', '审核管理', {
                        title: '进驻申请资料',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_1", "#009_1_1"],
                    permission: []
                }
            },
            {
                path: '/addTenant',
                name: '新建商家',
                component: addTenant,
                meta: {
                    title: '新建商家',
                    bread: ['商家与品牌', '商家管理', {
                        title: '新建商家',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_2"],
                    permission: []
                }
            },
            {
                path: '/listTenantClub',
                name: '俱乐部管理',
                component: listTenantClub,
                meta: {
                    title: '俱乐部管理',
                    bread: ['商家与品牌', {
                        title: '俱乐部管理',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_3"],
                    permission: []
                }
            },
            {
                path: '/addTenantClub',
                name: '商家新建俱乐部',
                component: addTenantClub,
                meta: {
                    title: '新建俱乐部',
                    bread: ['商家与品牌', '俱乐部管理', {
                        title: '新建俱乐部',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_3"],
                    permission: []
                }
            },
            {
                path: '/editTenantClub',
                name: '俱乐部详情页',
                component: editTenantClub,
                meta: {
                    title: '俱乐部详情页',
                    bread: ['商家与品牌', '俱乐部管理', {
                        title: '俱乐部详情页',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_3"],
                    permission: []
                }
            },
            {
                path: '/listTenantPost',
                name: '商家驿站管理',
                component: listTenantPost,
                meta: {
                    title: '驿站管理',
                    bread: ['商家与品牌', {
                        title: '驿站管理',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_4"],
                    permission: []
                }
            },
            {
                path: '/listTenantVenue',
                name: '商家场地管理',
                component: listTenantVenue,
                meta: {
                    title: '场地管理',
                    bread: ['商家与品牌', {
                        title: '场地管理',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_5"],
                    permission: []
                }
            },
            {
                path: '/listTenantBikeStore',
                name: '商家车店管理',
                component: listTenantBikeStore,
                meta: {
                    title: '车店管理',
                    bread: ['商家与品牌', {
                        title: '车店管理',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_6"],
                    permission: []
                }
            },
            {
                path: '/listTenantTherapy',
                name: '商家理疗师服务商管理',
                component: listTenantTherapy,
                meta: {
                    title: '理疗师服务商管理',
                    bread: ['商家与品牌', {
                        title: '理疗师服务商管理',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_7"],
                    permission: []
                }
            },
            {
                path: '/addTenantTherapy',
                name: '新建理疗服务商',
                component: addTenantTherapy,
                meta: {
                    title: '新建理疗师服务商',
                    bread: ['商家与品牌', '理疗师服务商管理', {
                        title: '新建理疗师服务商',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_7"],
                    permission: []
                }
            },
            {
                path: '/editTenantTherapy',
                name: '编辑理疗服务商',
                component: editTenantTherapy,
                meta: {
                    title: '编辑理疗服务商',
                    bread: ['商家与品牌', '理疗师服务商管理', {
                        title: '编辑理疗服务商',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_7"],
                    permission: []
                }
            },
            {
                path: '/addTherapist',
                name: '新建理疗师',
                component: addTherapist,
                meta: {
                    title: '新建理疗师',
                    bread: ['商家与品牌', '理疗师服务商管理', '编辑理疗服务商', {
                        title: '新建理疗师',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_7"],
                    permission: []
                }
            },
            {
                path: '/editTherapist',
                name: '编辑理疗师',
                component: editTherapist,
                meta: {
                    title: '编辑理疗师',
                    bread: ['商家与品牌', '理疗师服务商管理', '编辑理疗服务商', {
                        title: '编辑理疗师',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_7"],
                    permission: []
                }
            },
            {
                path: '/listTenantPhotography',
                name: '摄影师服务商管理',
                component: listTenantPhotography,
                meta: {
                    title: '摄影师服务商管理',
                    bread: ['商家与品牌', {
                        title: '摄影师服务商管理',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_8"],
                    permission: []
                }
            },
            {
                path: '/addTenantPhotography',
                name: '新建摄影师服务商',
                component: addTenantPhotography,
                meta: {
                    title: '新建摄影师服务商',
                    bread: ['商家与品牌', '摄影师服务商管理', {
                        title: '新建摄影师服务商',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_8"],
                    permission: []
                }
            },
            {
                path: '/editTenantPhotography',
                name: '编辑摄影师服务商',
                component: editTenantPhotography,
                meta: {
                    title: '编辑摄影师服务商',
                    bread: ['商家与品牌', '摄影师服务商管理', {
                        title: '编辑摄影师服务商',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_8"],
                    permission: []
                }
            },
            {
                path: '/addPhotographer',
                name: '新建摄影师',
                component: addPhotographer,
                meta: {
                    title: '新建摄影师',
                    bread: ['商家与品牌', '编辑摄影服务商', {
                        title: '新建摄影师',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_8"],
                    permission: []
                }
            },
            {
                path: '/editPhotographer',
                name: '编辑摄影师',
                component: editPhotographer,
                meta: {
                    title: '编辑摄影师',
                    bread: ['商家与品牌', '编辑摄影服务商', {
                        title: '编辑摄影师',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_8"],
                    permission: []
                }
            },
            {
                path: '/addTenantPost',
                name: '商家新建驿站',
                component: addTenantPost,
                meta: {
                    title: '新建驿站',
                    bread: ['商家与品牌', '驿站管理', {
                        title: '新建驿站',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_4"],
                    permission: []
                }
            },
            {
                path: '/editTenantPost',
                name: '商家编辑驿站',
                component: editTenantPost,
                meta: {
                    title: '编辑驿站',
                    bread: ['商家与品牌', '驿站管理', {
                        title: '编辑驿站',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_4"],
                    permission: []
                }
            },
            {
                path: '/addTenantVenue',
                name: '商家新建场地',
                component: addTenantVenue,
                meta: {
                    title: '新建场地',
                    bread: ['商家与品牌', '场地管理', {
                        title: '新建场地',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_5"],
                    permission: []
                }
            },
            {
                path: '/editTenantVenue',
                name: '商家编辑场地',
                component: editTenantVenue,
                meta: {
                    title: '编辑场地',
                    bread: ['商家与品牌', '场地管理', {
                        title: '编辑场地',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_5"],
                    permission: []
                }
            },
            {
                path: '/addTenantBikeStore',
                name: '商家新建车店',
                component: addTenantBikeStore,
                meta: {
                    title: '新建车店',
                    bread: ['商家与品牌', '车店管理', {
                        title: '新建车店',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_6"],
                    permission: []
                }
            },
            {
                path: '/editTenantBikeStore',
                name: '商家编辑车店',
                component: editTenantBikeStore,
                meta: {
                    title: '编辑车店',
                    bread: ['商家与品牌', '车店管理', {
                        title: '编辑车店',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_6"],
                    permission: []
                }
            },
            {
                path: '/listTherapyOrderIgnore',
                name: '理疗服务订单',
                component: listTherapyOrderIgnore,
                meta: {
                    title: '理疗服务订单',
                    bread: ['商家与品牌', '订单管理', {
                        title: '理疗服务订单',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_6"],
                    permission: []
                }
            },
            {
                path: '/listPhotographyOrderIgnore',
                name: '摄影服务订单',
                component: listPhotographyOrderIgnore,
                meta: {
                    title: '摄影服务订单',
                    bread: ['商家与品牌', '订单管理', {
                        title: '摄影服务订单',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_6"],
                    permission: []
                }
            },
            {
                path: '/listBikeMaintenanceOrderIgnore',
                name: '整装保养订单',
                component: listBikeMaintenanceOrderIgnore,
                meta: {
                    title: '整装保养订单',
                    bread: ['商家与品牌', '订单管理', {
                        title: '整装保养订单',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_6"],
                    permission: []
                }
            },
            {
                path: '/listPostOrderIgnore',
                name: '驿站订单',
                component: listPostOrderIgnore,
                meta: {
                    title: '驿站订单',
                    bread: ['商家与品牌', '订单管理', {
                        title: '驿站订单',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_6"],
                    permission: []
                }
            },
            {
                path: '/addBikeStoreMember',
                name: '新建车店店员',
                component: addBikeStoreMember,
                meta: {
                    title: '新建车店店员',
                    bread: ['商家与品牌', '车店管理', {
                        title: '新建车店店员',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_6"],
                    permission: []
                }
            },
            {
                path: '/editBikeStoreMember',
                name: '编辑车店店员',
                component: editBikeStoreMember,
                meta: {
                    title: '编辑车店店员',
                    bread: ['商家与品牌', '车店管理', {
                        title: '编辑车店店员',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_6"],
                    permission: []
                }
            },
            {
                path: '/addVenueCoach',
                name: '新建场地教练',
                component: addVenueCoach,
                meta: {
                    title: '新建场地教练',
                    bread: ['商家与品牌', '场地', {
                        title: '新建场地教练',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_5"],
                    permission: []
                }
            },
            {
                path: '/editVenueCoach',
                name: '编辑场地教练',
                component: editVenueCoach,
                meta: {
                    title: '编辑场地教练',
                    bread: ['商家与品牌', '场地', {
                        title: '编辑场地教练',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_5"],
                    permission: []
                }
            },
            {
                path: '/addActivity',
                name: '发布活动',
                component: eventAddActivity,
                meta: {
                    title: '发布活动',
                    bread: ['事项管理', {
                        title: '发布活动',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#010", "#010_1"],
                    permission: []
                }
            },
            {
                path: '/listActivity',
                name: '运营平台 - 活动管理',
                component: eventListActivity,
                meta: {
                    title: '活动管理',
                    bread: ['事项管理', {
                        title: '活动管理',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#010", "#010_2"],
                    permission: []
                }
            },
            {
                path: '/listTenantBrand',
                name: '品牌方管理',
                component: listTenantBrand,
                meta: {
                    title: '品牌方管理',
                    bread: ['商家与品牌', {
                        title: '品牌方管理',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_9"],
                    permission: []
                }
            },
            {
                path: '/addTenantBrand',
                name: '新建品牌方',
                component: addTenantBrand,
                meta: {
                    title: '新建品牌方',
                    bread: ['商家与品牌', '品牌方管理',{
                        title: '新建品牌方',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_9"],
                    permission: []
                }
            },
            {
                path: '/editTenantBrand',
                name: '编辑品牌方',
                component: editTenantBrand,
                meta: {
                    title: '编辑品牌方',
                    bread: ['商家与品牌', '品牌方管理',{
                        title: '编辑品牌方',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_9"],
                    permission: []
                }
            },
            {
                path: '/addBrandMember',
                name: '新建员工',
                component: addBrandMember,
                meta: {
                    title: '新建员工',
                    bread: ['商家与品牌', '品牌方管理', '编辑品牌方', {
                        title: '新建员工',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_9"],
                    permission: []
                }
            },
            {
                path: '/editBrandMember',
                name: '编辑员工',
                component: editBrandMember,
                meta: {
                    title: '编辑员工',
                    bread: ['商家与品牌', '品牌方管理', '编辑品牌方', {
                        title: '编辑员工',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#009", "#009_9"],
                    permission: []
                }
            },
            {
                path: '/listItemBizCategory',
                name: '商品类目',
                component: listItemBizCategory,
                meta: {
                    title: '商品类目',
                    bread: ['设置', '商品', {
                        title: '商品类目',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#005", "#005_3", "#005_3_6"],
                    permission: []
                }
            },
            {
                path: '/editPrimaryCategory',
                name: '一级类目',
                component: editPrimaryCategory,
                meta: {
                    title: '一级类目',
                    bread: ['设置', '商品', '商品类目', {
                        title: '一级类目',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#005", "#005_3", "#005_3_6"],
                    permission: []
                }
            },
            {
                path: '/editSecondaryCategory',
                name: '二级类目',
                component: editSecondaryCategory,
                meta: {
                    title: '二级类目',
                    bread: ['设置', '商品', '商品类目', {
                        title: '二级类目',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#005", "#005_3", "#005_3_6"],
                    permission: []
                }
            },
            {
                path: '/listMallOrderManage',
                name: '商城订单',
                component: listMallOrderManage,
                meta: {
                    title: '商城订单',
                    bread: ['订单管理', {
                        title: '商城订单',
                        color: 'primary',
                        disabled: false
                    }],
                    open: ["#011", "#011_1"],
                    permission: []
                }
            },
        ],
    },
    {
        // path: '/index',
        name: 'templateNew',
        component: YTindex,
        children: [
            {
                path: '/store/settings',
                name: '设置',
                component: settings,
                meta: {
                    title: '设置',
                    bread: [],
                    open: ["#4"],
                    permission: []
                }
            },
            {
                path: '/store/manageClub',
                name: '管理俱乐部',
                component: manageClub,
                meta: {
                    title: '管理俱乐部',
                    bread: [],
                    open: ["#3"],
                    permission: []
                }
            },
            {
                path: '/store/listUser',
                name: '会员管理',
                component: listUser,
                meta: {
                    title: '会员管理',
                    bread: [],
                    open: ["#1"],
                    permission: []
                }
            },
            {
                path: '/store/listUserAudit',
                name: '新会员审核',
                component: listUserAudit,
                meta: {
                    title: '会员审核',
                    bread: ['会员管理', {
                        title: '会员审核',
                        color: '#000000',
                        disabled: false
                    }],
                    open: ["#1"],
                    permission: []
                }
            },
            {
                path: '/store/listActivity',
                name: '活动管理',
                component: listActivity,
                meta: {
                    title: '活动管理',
                    bread: [],
                    open: ["#2"],
                    permission: []
                }
            },
            {
                path: '/store/editActivity',
                name: '发布新活动',
                component: editActivity,
                meta: {
                    title: '发布新活动',
                    bread: [{
                        title: '发布新活动',
                        color: '#000000',
                        disabled: false
                    }],
                    open: ["#2"],
                    permission: []
                }
            },
            {
                path: '/store/listUserHistoryAudit',
                name: '历史审核',
                component: listUserHistoryAudit,
                meta: {
                    title: '历史审核',
                    bread: ['会员管理', '会员审核', {
                        title: '历史审核',
                        color: '#000',
                        disabled: false
                    }],
                    open: ["#1"],
                    permission: []
                }
            },
            {
                path: '/store/editClub',
                name: '编辑资料',
                component: YTCreateClub,
                meta: {
                    title: '编辑资料',
                    bread: ['设置', {
                        title: '编辑资料',
                        color: '#000',
                        disabled: false
                    }],
                    open: ["#3"],
                    permission: []
                }
            },
            {
                path: '/store/listMallOrderManage',
                name: '商家 - 商城订单管理',
                component: listMallOrderManageStore,
                meta: {
                    title: '商城订单管理',
                    bread: [],
                    open: ["#5"],
                    permission: []
                }
            },
        ]
    },
    {
        path: '/wechatBindFail',
        name: '微信绑定失败',
        component: wechatBindFail,
        meta: {
            title: 'wechatBindFail'
        }
    },
    {
        path: '/wechatBindSuccess',
        name: '微信绑定成功',
        component: wechatBindSuccess,
        meta: {
            title: 'wechatBindSuccess'
        }
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: "/404.html"
    },
    {
        path: '/404.html',
        name: 'notFound',
        component: NotFound,
        meta: {
            title: '404'
        }
    }
]
const router = createRouter({
    history: createWebHistory(),
    routes
})

// 路由白名单
const whiteList = ['/login', '/404.html', '/superAdminLogin', '/wechatBindFail', '/wechatBindSuccess', 'apple-app-site-association']
// 路由守卫
router.beforeEach(async (to, from, next) => {
    const token = userTokenStore().token;
    const userInfo = userInfoStore().info
    // 路由过滤非白名单路由并且未有登录token的路由请求到登录页面
    if (!whiteList.some(item => item === to.path) && !token) {
        ElMessage({
            type: 'error',
            message: '请先登录！'
        });
        next('/login');
        return;
    }
    if (userInfo.tenantId === "101" && token) {
        // 访问根目录跳转到菜单列表第一个可选菜单
        if (to.path === "/") {
            try {
                const targetPath = await handleGetMenuFirst(); // 直接获取目标路径
                return next(targetPath || '/listMember'); // 兜底路径
            } catch (err) {
                console.error('获取菜单失败:', err);
                return next('/listMember'); // 异常兜底
            }
        }
        // 已登录则跳转到首页（菜单第一个可选跳转）
        if ((to.path === '/login' || to.path === '/superAdminLogin') && token) {
            console.log("to.path", to.path)
            try {
                const targetPath = await handleGetMenuFirst(); // 直接获取目标路径
                return next(targetPath || '/listMember'); // 兜底路径
            } catch (err) {
                console.error('获取菜单失败:', err);
                return next('/listMember'); // 异常兜底
            }
        }
    } else {
        console.log("run in here")
        if (token && !whiteList.some(item => item === to.path)) {
            // 非 101 账号或登录类型为8（商家平台登录），只允许访问 /store/* 路径
            // if (!to.path.startsWith('/store') || to.path === "/") {
            //     return next('/store/listUser') // 非 store 路由直接拦截
            // }
        }
        if ((to.path === '/login' || to.path === '/superAdminLogin') && token) {
            return next('/store/listUser');
        }
    }

    // 配置网页title
    document.title = `${import.meta.env.VITE_API_TITLE} - ${to.meta.title || '骑么管理平台'}`;
    next();
});
export default router;
